module.exports = __webpack_public_path__ + "static/media/carousel1.b7df9677.jpeg";